<template>
  <div class="activity-tab">
    <div class="tab" v-if="title.constructor === Array">
      <div class="title" :class="{'active':ischeck == index}" v-for="(name,index) in  title" :key="index">
        <!-- <img :class="{'show':ischeck == index}" src="https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/assist-left.png" alt=""> -->
        <span class="tab-text" @click="handCheck(index)">{{name}}</span>
        <!-- <img :class="{'show':ischeck == index}" src="https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/assist-right.png" alt=""> -->
      </div>
    </div>
    <div v-else>
      <div class="title active">
        <span>{{title}}</span>
      </div>
    </div>
  </div>
</template>
 
<script>
export default {
  name: 'ActivityTitle',
  props: {
    title: {
      type: String | Object,
    }
  },
  data () {
    return {
      ischeck: 0,
      bgImg: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/home/home-title-bg.png'
    }
  },
  methods: {
    handCheck (index) {
      this.ischeck = index
      this.$emit("check", index)
    }
  }
}
</script>
 
<style scoped lang="less">
.activity-tab {
  height: 112px;
  text-align: center;
  margin: 30px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  .tab {
    display: flex;
    .tab-text {
      cursor: pointer;
    }
  }
  .title {
    display: flex;
    align-items: center;
    margin: 0 60px;
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    background: url("https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/home/home-title-bg.png");
    background-size: 100% 100%;

    span {
      padding: 0 16px;
    }
    img {
      width: 32px;
      height: 11px;
      opacity: 0;
    }
  }
  .active {
    font-size: 32px;
    font-weight: bold;
    color: #222222;
  }
  .show {
    opacity: 1 !important;
  }
}
</style>　　